import React, { useState, useEffect } from 'react'; // Importe useState e useEffect
import './QuemSomos.css';
import artisanImage from './artisan.jpg';

const QuemSomos = () => {
  const [opacity, setOpacity] = useState(0); // Estado para controlar a opacidade, começa em 0

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY; // Posição atual do scroll
      const windowHeight = window.innerHeight; // Altura da janela visível
      const containerTop = document.querySelector('.about-us-container').getBoundingClientRect().top;

      // Calcula um valor de opacidade baseado na posição do scroll
      // A imagem começa a aparecer quando o topo do container se aproxima do topo da viewport
      // e atinge opacidade máxima quando o container está totalmente visível.
      let newOpacity = 0;
      if (containerTop < windowHeight * 0.9) { // Começa a aparecer quando 90% do container está visível
        newOpacity = 1 - (containerTop / (windowHeight * 0.8));
        newOpacity = Math.min(Math.max(newOpacity, 0), 0.9); // Garante que a opacidade esteja entre 0 e 0.9
      }
      setOpacity(newOpacity);
    };

    window.addEventListener('scroll', handleScroll); // Adiciona o event listener
    handleScroll(); // Chama uma vez para definir a opacidade inicial caso a página já esteja rolada

    return () => {
      window.removeEventListener('scroll', handleScroll); // Remove o event listener ao desmontar o componente
    };
  }, []); // O array vazio garante que o efeito seja executado apenas uma vez ao montar

  return (
    <div className="about-us-container">
      {/* Aplica a opacidade diretamente via style */}
      <div
        className="background-image"
        style={{ backgroundImage: `url(${artisanImage})`, opacity: opacity }}
      ></div>
      <div className="content-overlay">
        <h1>Quem Somos</h1>

          <p>A <strong>Arce Design</strong> nasceu em março de 2011, pelas mãos de seu fundador <strong>Sandro Arce</strong>, que atua no ramo de móveis
           desde 1999. Sua paixão nessa área começou quando trabalhava na empresa <strong>Eviva</strong>, o que constituiu a semente para outras
            experiências em empresas do segmento de moveis planejados, como <strong>Dellano</strong> &copy;, <strong> Bom Tempo</strong> &copy;
             e <strong>Criare</strong> &copy;.</p>
          <p>Essas experiências ajudaram a moldar todas as nossas idéias, especialmente habilidade de ouvir as aspirações e desejos de nossos clientes,
            a paixão pela criação e pelo poder de transformar sonhos e idéias em móveis funcionais e integrados, com inteligência, estilo e sofisticação.</p>
          <p>A empresa atua hoje com maior agilidade e eficiência, desde a concepção do projeto até a instalação final, contando com softwares
            especializados, integrado a sistemas de corte e produção automatizados, com a apoio técnico de nossos parceiros e colaboradores.</p>
          <p>Como consequência, nossos clientes tiveram seus sonhos materializados em espaços personalizados e de alta qualidade, com design,
             funcionalidade e beleza para cada novo projeto. Hoje, a <strong>Arce Design</strong> &copy; é uma referência no mercado de móveis
             planejados em Manaus e região.</p>
          
          <p><strong>Você já imaginou e sonhou seu espaço ideal; agora é hora construi-lo conosco! Fale com a gente!</strong></p>
      </div>
    </div>
  );
};

export default QuemSomos;